import React, { Component } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import { getRiotAssetsContext, getIcon } from "@outplayed/riot-assets";
import ReactSVG from "react-svg";

const Error404 = (props) => {
  const { getChampionImg } = getRiotAssetsContext();
  const history = useHistory();
  const location = useLocation();

  const getClosestSearchMatch = () => {
    const searchResults = location && location.state && location.state.searchResults;
    if (Array.isArray(searchResults) && searchResults.length > 0) {
      return searchResults[0];
    }
    return null;
  };

  const didYouMean = getClosestSearchMatch();

  return (
    <div className="error-404 content-side-padding">
      {didYouMean && (
        <div className="did-you-mean">
          <img
            className="alert-icon"
            style={{ width: 40, marginRight: 15 }}
            src={getIcon("lol/icons/YUUWIECAREFULWATCHOUTALERTALERTGETDOOOOWN.svg")}
          />
          <div style={{ display: "flex", alignItems: "center" }}>
            <span>Did you mean to search for </span>
            <Link to={didYouMean.item.url}>
              <div className="champion-face">
                <img src={getChampionImg(didYouMean.item.id)} />
              </div>
              {didYouMean.item.key}
            </Link>
            <span>?</span>
          </div>
        </div>
      )}
      <div className="page-not-found">
        <div>
          <h1 className="text-center">404</h1>
          <h2 className="text-center">This page doesn't exist</h2>
        </div>
        <div>
          <p className="text-center">
            The page you're looking for isn't available.
            <br />
            Try to search again or use the back button.
          </p>
        </div>
        <div className="back-btn" onClick={() => history.goBack()}>
          <ReactSVG wrapperClassName="react-svg" path={"https://static.bigbrain.gg/assets/ugg/icons/chevron-back.svg"} />
          <span style={{ marginLeft: 15 }}>Back</span>
        </div>
      </div>
    </div>
  );
};

export default Error404;
